import React from 'react';

function StepIndicator({ currentStep }) {
  const steps = ['Personal Details', 'Address Details', 'Membership Type', 'Payment', 'Review'];

  return (
    <div className="mb-10">
      <div className="flex justify-between items-center">
        {steps.map((step, index) => (
          <div key={step} className="flex-1 flex flex-col items-center relative">
            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div className="hidden sm:block absolute top-5 left-1/2 w-full h-0.5 -z-10">
                <div
                  className={`h-full transition-all duration-300 ${
                    index < currentStep - 1
                      ? 'bg-gradient-to-r from-hdlcc-primary to-hdlcc-primaryLight'
                      : 'bg-hdlcc-gray/30'
                  }`}
                />
              </div>
            )}

            {/* Step Circle */}
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 mb-3 ${
                index === currentStep - 1
                  ? 'bg-gradient-to-br from-hdlcc-primary to-hdlcc-primaryLight text-white shadow-glow-primary scale-110'
                  : index < currentStep - 1
                    ? 'bg-gradient-to-br from-hdlcc-success to-hdlcc-success/80 text-white shadow-elevation-1'
                    : 'bg-hdlcc-mediumGray border-2 border-hdlcc-lightGray/20 text-hdlcc-textTertiary'
              }`}
            >
              {index < currentStep - 1 ? (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                index + 1
              )}
            </div>

            {/* Step Label */}
            <div
              className={`text-xs sm:text-sm text-center font-medium transition-all duration-300 ${
                index === currentStep - 1
                  ? 'text-hdlcc-primary font-bold'
                  : index < currentStep - 1
                    ? 'text-hdlcc-textSecondary'
                    : 'text-hdlcc-textTertiary'
              }`}
            >
              {step}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StepIndicator;
